import { render, staticRenderFns } from "./Rent1887.vue?vue&type=template&id=5158bf47"
import script from "./Rent1887.vue?vue&type=script&lang=js"
export * from "./Rent1887.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports